import React from 'react';
import ReactDOM from 'react-dom';
import LocationSettings from '../../features/admin/components/LocationSettings';
import ModalCloseButton from '../../shared/components/modals/ModalCloseButton';
import './LocationEditModal.css';

/**
 * LocationEditModal Component
 * Modal wrapper for editing location details
 * Wraps the LocationSettings component with modal styling and close functionality
 * Uses ReactDOM portal to render at root level for proper z-index positioning
 */
function LocationEditModal({ isOpen, locationId, token, onClose, currentUser }) {
  // Prevent body scroll when modal is open
  React.useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen || !locationId) return null;

  const content = (
    <div className="location-edit-modal-overlay">
      <div className="location-edit-modal">
        <div className="location-edit-modal-header">
          <h2>Edit Location</h2>
          <ModalCloseButton onClick={onClose} title="Close" />
        </div>

        {/* LocationSettings Component in Edit Mode */}
        <LocationSettings
          token={token}
          locationId={locationId}
          isCard={true}
          isEditingProp={true}
          onEditCancel={onClose}
          currentUser={currentUser}
        />
      </div>
    </div>
  );

  // Use ReactDOM Portal to render at root level
  return ReactDOM.createPortal(content, document.body);
}

export default LocationEditModal;
